import MenuContext from 'antd/es/menu/MenuContext'
import dayjs from 'dayjs'
import { v4 as uuidv4 } from 'uuid'
export const MenuCard: any = [
  {
    key: 'Breakfast',
    category_id: '1',
    label: 'Breakfast',
    children: [
      {
        key: 'Dosa',
        category_id: '1',
        label: 'Dosa',
        subcategory_id: '1',
        foodItems: [
          {
            key: 'Masala Dosa',
            subcategory_id: '1',
            label: 'Masala Dosa',
            price: 40,
            totalPrice: 50,
            description:
              'A south indian dosa containing delicious masala and a combination of potata crush inside, server with chutney',
            gst: 5,
            packaging: false,
            packaging_charges: null,
            servings: 1,
            category: 'Fresh',
            images: [
              {
                uid: 1,
                name: 'Screenshot_20221026_155428.png',
                status: 'done',
                url: 'https://firebasestorage.googleapis.com/v0/b/foodtollsvendorapp.appspot.com/o/FoodImages%2FScreenshot_20221026_155428.png?alt=media&token=d50bf6b0-afdb-42fd-99e1-234db7492429'
              },
              {
                uid: 2,
                name: 'Screenshot_20221026_155428.png',
                status: 'done',
                url: 'https://firebasestorage.googleapis.com/v0/b/foodtollsvendorapp.appspot.com/o/FoodImages%2FScreenshot_20221026_155428.png?alt=media&token=d50bf6b0-afdb-42fd-99e1-234db7492429'
              },
              {
                uid: 3,
                name: 'Screenshot_20221026_155428.png',
                status: 'done',
                url: 'https://firebasestorage.googleapis.com/v0/b/foodtollsvendorapp.appspot.com/o/FoodImages%2FScreenshot_20221026_155428.png?alt=media&token=d50bf6b0-afdb-42fd-99e1-234db7492429'
              },
              {
                uid: 4,
                name: 'Screenshot_20221026_155428.png',
                status: 'done',
                url: 'https://firebasestorage.googleapis.com/v0/b/foodtollsvendorapp.appspot.com/o/FoodImages%2FScreenshot_20221026_155428.png?alt=media&token=d50bf6b0-afdb-42fd-99e1-234db7492429'
              }
            ],
            availableDays: ['Wednesday', 'Thursday'],
            availableHours: {
              Monday: {
                workingHours: {
                  open: '',
                  close: ''
                }
              },
              Tuesday: {
                workingHours: {
                  open: '',
                  close: ''
                }
              },
              Wednesday: {
                workingHours: {
                  open: '',
                  close: ''
                }
              },
              Thursday: {
                workingHours: {
                  open: '06:00 AM',
                  close: '10:35 PM'
                }
              },
              Friday: {
                workingHours: {
                  open: '',
                  close: ''
                }
              },
              Saturday: {
                workingHours: {
                  open: '',
                  close: ''
                }
              },
              Sunday: {
                workingHours: {
                  open: '',
                  close: ''
                }
              }
            },
            ratings: { averageRatings: 0, ratingCount: 0 },
            type: 'VEG',
            healthy: false,
            vegan: false,
            recommend: false,
            cuisine: []
          }
        ]
      }
    ]
  }
]

const categoryEmptySet = {
  key: '',
  category_id: '',
  label: '',
  children: [],
  hasSubCategory: false
}

const subCategoryEmptySet = {
  key: '',
  category_id: '',
  label: '',
  subcategory_id: '',
  foodItems: []
}

const foodItemEmptySet = {
  key: '',
  category_id: '',
  subcategory_id: '',
  food_id: '',
  label: '',
  price: '',
  totalPrice: '',
  description: '',
  gstPercentage: 0,
  gst: 0,
  packaging: false,
  packaging_charges: 0,
  servings: 1,
  categoryType: '',
  status: 'Available',
  images: [],
  isAddon: false,
  addonGroupIds: [],
  availableDays: [],
  availableHours: {
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: []
  },
  ratings: { averageRatings: 0, ratingCount: 0 },
  type: '',
  vegan: false,
  healthy: false,
  recommend: false,
  cuisine: '',
  stock: {
    initialStockPerDay: 100,
    currentStock: 100,
    autoRefresh: true,
    nextRefreshAt: null
  },
  offers: [],
  combos: []
}

export const addCategory = (MenuCard: any, newCategory: string) => {
  console.log(MenuCard, newCategory)
  const newCategorySet = JSON.parse(JSON.stringify(categoryEmptySet))
  newCategorySet.key = newCategory
  newCategorySet.category_id = uuidv4()
  newCategorySet.label = newCategory
  MenuCard.push(newCategorySet)
  return MenuCard
}

export const addSubCategory = (
  MenuCard: any,
  category: string,
  newSubCategory: string
) => {
  console.log('yo insides ub')
  const reqCategory = findReqCategory(MenuCard, category)
  reqCategory.hasSubCategory = true
  const newSubCategorySet = JSON.parse(JSON.stringify(subCategoryEmptySet))
  newSubCategorySet.key = newSubCategory
  newSubCategorySet.category_id = category
  newSubCategorySet.label = newSubCategory
  console.log(reqCategory)
  newSubCategorySet.subcategory_id = uuidv4()
  reqCategory.children.push(newSubCategorySet)
  return MenuCard
}

export const addFoodItem = (
  MenuCard: any,
  category: string,
  subCategory: string,
  newFoodItem: string,
  workingDaysHours: any
) => {
  console.log(MenuCard, category, subCategory, newFoodItem, workingDaysHours)
  const reqSubCategory = findReqSubCategory(MenuCard, category, subCategory)
  console.log('yo', reqSubCategory)
  const newFoodItemSet = JSON.parse(JSON.stringify(foodItemEmptySet))

  newFoodItemSet.key = newFoodItem
  newFoodItemSet.category_id = category
  newFoodItemSet.subcategory_id = subCategory
  newFoodItemSet.label = newFoodItem
  Object.keys(workingDaysHours).forEach((day) => {
    workingDaysHours[day].restaurantOpen !== 'Open'
      ? delete newFoodItemSet.availableHours[day]
      : ''
  })
  newFoodItemSet.food_id = uuidv4()

  reqSubCategory.foodItems.push(newFoodItemSet)
  console.log('yo2', MenuCard)

  return MenuCard
}

export const addFoodItemToCategory = (
  MenuCard: any,
  category: string,
  newFoodItem: string,
  workingDaysHours: any
) => {
  console.log(MenuCard, category, newFoodItem, workingDaysHours)
  const newFoodItemSet = JSON.parse(JSON.stringify(foodItemEmptySet))
  newFoodItemSet.key = newFoodItem
  newFoodItemSet.category_id = category
  newFoodItemSet.label = newFoodItem
  Object.keys(workingDaysHours).forEach((day) => {
    workingDaysHours[day].restaurantOpen !== 'Open'
      ? delete newFoodItemSet.availableHours[day]
      : ''
  })
  const reqCategory = findReqCategory(MenuCard, category)
  newFoodItemSet.food_id = uuidv4()
  reqCategory.children.push(newFoodItemSet)
  console.log('yo2', MenuCard)

  return MenuCard
}

export const deleteCategory = (MenuCard: any, category_id: string) => {
  const categoryIndex = MenuCard.findIndex(
    (card: any) => card.category_id === category_id
  )
  MenuCard.splice(categoryIndex, 1)
  return MenuCard.map((menu: any) => menu)
}

export const deleteSubCategory = (
  MenuCard: any,
  category_id: string,
  subCategory_id: string
) => {
  console.log(MenuCard, category_id, subCategory_id)
  const categoryIndex = MenuCard.findIndex(
    (card: any) => card.category_id === category_id
  )
  if (MenuCard[categoryIndex].hasSubCategory) {
    const subCategoryIndex = MenuCard[categoryIndex].children.findIndex(
      (subCategory: any) => subCategory.subcategory_id === subCategory_id
    )
    MenuCard[categoryIndex].children.splice(subCategoryIndex, 1)
    console.log(MenuCard)
  }

  return MenuCard.map((menu: any) => menu)
}

export const deleteFoodItem = (
  MenuCard: any,
  category_id: string,
  subCategory_id: string,
  food_id: string
) => {
  console.log(category_id, subCategory_id, food_id)
  const categoryIndex = MenuCard.findIndex(
    (card: any) => card.category_id === category_id
  )
  console.log(categoryIndex, MenuCard[categoryIndex])
  let subCategoryIndex = undefined
  if (subCategory_id) {
    subCategoryIndex = MenuCard[categoryIndex].children.findIndex(
      (subCategory: any) => subCategory.subcategory_id === subCategory_id
    )
  }
  console.log(subCategoryIndex)
  const foodItemIndex =
    subCategoryIndex > -1
      ? MenuCard[categoryIndex].children[subCategoryIndex].foodItems.findIndex(
          (foodItem: any) => foodItem.food_id === food_id
        )
      : MenuCard[categoryIndex].children.findIndex(
          (foodItem: any) => foodItem.food_id === food_id
        )
  if (subCategoryIndex > -1) {
    MenuCard[categoryIndex].children[subCategoryIndex].foodItems.splice(
      foodItemIndex,
      1
    )
  } else {
    MenuCard[categoryIndex].children.splice(foodItemIndex, 1)
  }
  console.log(MenuCard)
  return MenuCard.map((menu: any) => menu)
}

export const updateItemStatus = (
  MenuCard: any,
  category_id: string,
  subCategory_id: string,
  food_id: string
) => {
  const categoryIndex = MenuCard.findIndex(
    (card: any) => card.category_id === category_id
  )
  // console.log(categoryIndex, MenuCard[categoryIndex])
  const subCategoryIndex = MenuCard[categoryIndex].children.findIndex(
    (subCategory: any) => subCategory.subcategory_id === subCategory_id
  )

  const foodItemIndex = MenuCard[categoryIndex].children[
    subCategoryIndex
  ].foodItems.findIndex((foodItem: any) => foodItem.food_id === food_id)

  MenuCard[categoryIndex].children[subCategoryIndex].foodItems[
    foodItemIndex
  ].status =
    MenuCard[categoryIndex].children[subCategoryIndex].foodItems[foodItemIndex]
      .status === 'Available'
      ? 'Not-Available'
      : 'Available'

  return MenuCard.map((map: any) => map)
}

export const updateFoodItem = (foodItemList: any, foodDetails: any) => {
  console.log(foodItemList, foodDetails)
  Object.entries(foodDetails).forEach(([key, value]) => {
    if (key === 'availableDays') {
      foodDetails[key].forEach((workday: string) => {
        foodItemList.availableHours[workday] = foodDetails[workday]
      })
      foodItemList[key] = value
    } else {
      console.log(foodItemList[key], value)
      if (key === 'price' || key === 'totalPrice') {
        Object.hasOwn(foodItemList, key) && typeof value === 'string'
          ? (foodItemList[key] = parseInt(value))
          : (foodItemList[key] = value)
      } else if (key === 'packaging_charges') {
        Object.hasOwn(foodItemList, key) && typeof value === 'string'
          ? (foodItemList[key] = parseFloat(value))
          : (foodItemList[key] = value)
      } else {
        Object.hasOwn(foodItemList, key) ? (foodItemList[key] = value) : ''
      }
    }
  })

  // For packaged food items, set GST and gstPercentage to 0
  if (foodItemList.categoryType === 'Packaged') {
    foodItemList.gst = 0
    foodItemList.gstPercentage = 0
  } else if (
    // Calculate GST if price and gstPercentage are available
    foodItemList.price &&
    foodItemList.gstPercentage !== undefined
  ) {
    const price =
      typeof foodItemList.price === 'string'
        ? parseFloat(foodItemList.price)
        : foodItemList.price
    const gstPercentage =
      typeof foodItemList.gstPercentage === 'string'
        ? parseFloat(foodItemList.gstPercentage)
        : foodItemList.gstPercentage
    foodItemList.gst = Number(((price * gstPercentage) / 100).toFixed(2))
  } else if (!foodItemList.gst || foodItemList.gst === '') {
    foodItemList.gst = 0
  }

  console.log(foodItemList)
}

export const getFoodList = (
  Menu: any,
  category: string,
  subCategory: string
) => {
  console.log(category, subCategory)
  const reqFoodList = findReqSubCategory(
    Menu,
    category,
    subCategory,
    'label'
  ).foodItems
  return reqFoodList
}

export const getFoodListByCategory = (Menu: any, category: string) => {
  const reqFoodList = findReqCategory(Menu, category, 'label')
  console.log(reqFoodList)
  return reqFoodList.children
}

export const getMenuSubCategoryList = (Menu: any, category: string) => {
  console.log(Menu, category)
  const reqCategory = findReqCategory(Menu, category)
  // console.log(reqCategory)
  const subCategoryList = reqCategory.children.map((subCategory: any) => {
    return { value: subCategory.subcategory_id, label: subCategory.label }
  })
  return subCategoryList
}

export const findReqCategory = (
  Menu: any,
  category: string,
  queryType?: string
) => {
  return Menu.find((categoryItem: any) => {
    return queryType === 'label'
      ? categoryItem.key === category
      : categoryItem.category_id === category
  })
}

export const fetchAddOns = (Menu: any) => {
  console.log(Menu)
  // This function is deprecated - addon groups are now stored separately
  // Return empty array for backward compatibility
  return []
}

export const findReqSubCategory = (
  Menu: any,
  category: string,
  subCategory: string,
  queryType?: string
) => {
  const reqCategory =
    queryType === 'label'
      ? findReqCategory(Menu, category, 'label')
      : findReqCategory(Menu, category)
  return reqCategory.children.find((subCategoryItem: any) => {
    return queryType === 'label'
      ? subCategoryItem.key === subCategory
      : subCategoryItem.subcategory_id === subCategory
  })
}

// Addon Group Management Functions
export const addAddonGroup = (addonGroups: any[], newGroup: any) => {
  const group = {
    group_id: uuidv4(),
    label: newGroup.label,
    selectionType: newGroup.selectionType,
    minSelect: newGroup.minSelect || 0,
    maxSelect: newGroup.maxSelect || 1,
    addons: newGroup.addons.map((addon: any, index: number) => ({
      addon_id: addon.addon_id, // This now references food_id
      isDefault: addon.isDefault || false,
      isActive: addon.isActive !== undefined ? addon.isActive : true,
      sortOrder: addon.sortOrder || index + 1
    }))
  }
  addonGroups.push(group)
  return addonGroups
}

export const updateAddonGroup = (
  addonGroups: any[],
  groupId: string,
  updatedGroup: any
) => {
  const groupIndex = addonGroups.findIndex((g: any) => g.group_id === groupId)
  if (groupIndex !== -1) {
    addonGroups[groupIndex] = {
      ...addonGroups[groupIndex],
      ...updatedGroup,
      group_id: groupId, // Preserve original group_id
      addons: updatedGroup.addons.map((addon: any, index: number) => ({
        addon_id: addon.addon_id, // This now references food_id
        isDefault: addon.isDefault || false,
        isActive: addon.isActive !== undefined ? addon.isActive : true,
        sortOrder: addon.sortOrder || index + 1
      }))
    }
  }
  return addonGroups
}

export const deleteAddonGroup = (addonGroups: any[], groupId: string) => {
  return addonGroups.filter((g: any) => g.group_id !== groupId)
}

// Helper function to get all food items marked as addons
export const getAddonFoodItems = (menuCard: any[]): any[] => {
  const addonItems: any[] = []

  menuCard.forEach((category: any) => {
    if (category.hasSubCategory) {
      // Has subcategories
      category.children.forEach((subCategory: any) => {
        if (subCategory.foodItems) {
          subCategory.foodItems.forEach((foodItem: any) => {
            if (foodItem.isAddon) {
              addonItems.push(foodItem)
            }
          })
        }
      })
    } else {
      // Direct food items under category
      category.children.forEach((foodItem: any) => {
        if (foodItem.isAddon) {
          addonItems.push(foodItem)
        }
      })
    }
  })

  return addonItems
}

// Helper function to find which addon groups are using a specific food item
export const getGroupsUsingFoodItem = (
  foodId: string,
  addonGroups: any[]
): { groupIds: string[]; groupNames: string[] } => {
  const groupIds: string[] = []
  const groupNames: string[] = []

  addonGroups.forEach((group: any) => {
    const usesItem = group.addons?.some(
      (addon: any) => addon.addon_id === foodId
    )
    if (usesItem) {
      groupIds.push(group.group_id)
      groupNames.push(group.label)
    }
  })

  return { groupIds, groupNames }
}

// Helper function to resolve food item by ID across all categories
export const resolveFoodItemById = (menuCard: any[], foodId: string): any => {
  for (const category of menuCard) {
    if (category.hasSubCategory) {
      // Has subcategories
      for (const subCategory of category.children) {
        if (subCategory.foodItems) {
          const foodItem = subCategory.foodItems.find(
            (item: any) => item.food_id === foodId
          )
          if (foodItem) return foodItem
        }
      }
    } else {
      // Direct food items under category
      const foodItem = category.children.find(
        (item: any) => item.food_id === foodId
      )
      if (foodItem) return foodItem
    }
  }
  return null
}
